import { useEffect, useRef, useState } from 'react'

export default function useBreakpoint() {
  const [breakpoint, setBreakpoint] = useState({
    sm: false,
    md: false,
    lg: false
  })
  const breakpointRef = useRef({
    sm: false,
    md: false,
    lg: false
  })

  useEffect(() => {
    const handleResize = () => {
      const newBreakpoints = {
        sm: window.innerWidth < 768,
        md: window.innerWidth >= 768 && window.innerWidth < 1700,
        lg: window.innerWidth >= 1700
      }

      if (newBreakpoints.sm !== breakpointRef.current.sm || newBreakpoints.md !== breakpointRef.current.md || newBreakpoints.lg !== breakpointRef.current.lg) {
        setBreakpoint(newBreakpoints)
        breakpointRef.current = newBreakpoints
      }
    }
    window.addEventListener('resize', handleResize)
    handleResize()
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return breakpoint
}
